import React from 'react';
import { Box, Typography, Paper, Button } from '@mui/material';
import { useKeycloak } from '../contexts/KeycloakContext';

const KeycloakDebug = () => {
  const { keycloak, isAuthenticated, user, token } = useKeycloak();

  const debugInfo = {
    isAuthenticated,
    hasToken: !!token,
    tokenExpired: keycloak?.isTokenExpired?.(),
    tokenParsed: keycloak?.tokenParsed,
    user,
    keycloakReady: keycloak?.authenticated,
    subject: keycloak?.subject,
    realm: keycloak?.realm,
    clientId: keycloak?.clientId,
    authServerUrl: keycloak?.authServerUrl,
  };

  const handleForceLogin = () => {
    keycloak?.login();
  };

  const handleCheckToken = () => {
    console.log('Current Keycloak state:', {
      authenticated: keycloak?.authenticated,
      token: keycloak?.token,
      tokenParsed: keycloak?.tokenParsed,
      isTokenExpired: keycloak?.isTokenExpired?.(),
    });
  };

  return (
    <Box p={3}>
      <Typography variant="h4" gutterBottom>
        Keycloak Debug Information
      </Typography>
      
      <Paper elevation={3} sx={{ p: 2, mb: 2 }}>
        <Typography variant="h6" gutterBottom>
          Authentication Status
        </Typography>
        <pre style={{ fontSize: '12px', overflow: 'auto' }}>
          {JSON.stringify(debugInfo, null, 2)}
        </pre>
      </Paper>

      <Box display="flex" gap={2}>
        <Button variant="contained" onClick={handleForceLogin}>
          Force Login
        </Button>
        <Button variant="outlined" onClick={handleCheckToken}>
          Check Token (Console)
        </Button>
      </Box>
    </Box>
  );
};

export default KeycloakDebug;
